import React from 'react';
type SectionProps = {
  id?: string;
  eyebrow?: string;
  title?: React.ReactNode;
  children: React.ReactNode;
  tone?: 'dark' | 'darker';
  className?: string;
};
export function Section({
  id,
  eyebrow,
  title,
  children,
  tone = 'dark',
  className = ''
}: SectionProps) {
  return <section id={id} className={`border-b border-ink-700 ${tone === 'dark' ? 'bg-ink-900' : 'bg-ink-950'} ${className}`} data-id="element-133" data-mp="3kv8dilxkoevh">
      <div className="mx-auto max-w-4xl px-5 py-14 sm:py-20" data-id="element-134" data-mp="cgpw3tlqrmz7">
        {eyebrow ? <p className="mb-3 text-xs font-bold uppercase tracking-[0.22em] text-shield-500" data-id="element-135" data-mp="hehwlc0gchf0">
            {eyebrow}
          </p> : null}
        {title ? <h2 className="mb-7 font-display text-2xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-136" data-mp="2pc2g2gh1hdz">
            {title}
          </h2> : null}
        {children}
      </div>
    </section>;
}